// extracted by mini-css-extract-plugin
module.exports = {"shippingRestrictionsText":"ShippingRestrictions_shippingRestrictionsText___sqPu","shippingRestrictionsSpace":"ShippingRestrictions_shippingRestrictionsSpace__2Eail"};